module.exports = __webpack_public_path__ + "static/khanacademy-28529bb2392bbaa658abd390035dff89.png";